import * as sup from 'superstruct';

import { JsonApiClient } from '@/modules/api/utils/createJsonApiClient';
import { createResponseStruct } from '@/modules/api/utils/jsonApiStructs';

import { getUpdateDemoNegotiationResourcePath } from '../../resources/demoNegotiation/demoNegotiationResourceConsts';
import { demoNegotiationResourceStruct } from '../resources/demoNegotiationResourceConsts';

type UpdateDemoNegotiationPayload = {
  negotiationId: string;
  title?: string;
  totalSpend?: number;
  suppliersCount?: number;
  periodIndex?: number | null;
};

export function updateDemoNegotiationMutation(jsonApi: JsonApiClient) {
  return async ({
    negotiationId,
    title,
    totalSpend,
    suppliersCount,
    periodIndex,
  }: UpdateDemoNegotiationPayload) => {
    const response = await jsonApi.update({
      path: getUpdateDemoNegotiationResourcePath(negotiationId),
      type: 'demo_negotiation',
      id: negotiationId,
      attributes: {
        periodIndex,
        title,
        totalSpend,
        suppliersCount,
      },
      responseStruct: updateDemoNegotiationResponseStruct,
    });
    if (!response)
      throw new Error('missing response from `UpdateDemoNegotiation`');

    return parseUpdateDemoNegotiationResponse(response);
  };
}

export const updateDemoNegotiationResponseStruct = createResponseStruct({
  data: demoNegotiationResourceStruct,
});

type UpdateDemoNegotiationResponse = sup.Infer<
  typeof updateDemoNegotiationResponseStruct
>;

function parseUpdateDemoNegotiationResponse(
  response: UpdateDemoNegotiationResponse
) {
  const {
    data: { id, attributes },
  } = response;

  return {
    id,
    ...attributes,
  };
}
